<template>
    <section class="additional-menu">
        <ul class="resident-portal-menu__list">
            <li v-if="isPortalActive" class="resident-portal-menu__item">
                <a class="additional-menu__link-wrapper resident-portal-menu__row"
                   :href="residentPortal.baseAddress"
                   target="_blank"
                   rel="noopener noreferrer">
                    <span class="additional-menu__link">{{ $t('com.file.nav-data.resident-portal-open') }}</span>
                </a>
            </li>
            <li v-if="isManagementAvailable" class="resident-portal-menu__item">
                <button type="button"
                        class="additional-menu__link-wrapper resident-portal-menu__row"
                        @click="openManagement">
                    <span class="additional-menu__link">{{ $t('com.file.nav-data.resident-portal-manage') }}</span>
                </button>
            </li>
        </ul>
    </section>
</template>

<script charset="utf-8">
import UserService from "../../../services/user.service";

export default {
    name: "AdditionalMenuResidentPortal",
    computed: {
        residentPortal() {
            return this.$store.state.userStore.residentPortal;
        },
        isPortalActive() {
            return this.residentPortal?.isActive === true;
        },
        isManagementAvailable() {
            return this.residentPortal?.isManagementAvailable === true;
        }
    },
    methods: {
        async openManagement() {
            try {
                this.$store.commit("showLoader");
                await UserService.openResidentPortalManagement();
            }
            finally {
                this.$store.commit("hideLoader");
            }
        }
    },
};
</script>

<style lang="scss" scoped>
    @use "../../../assets/scss/additional-menu.scss";

    .additional-menu {
        margin-top: 0px !important;
    }

    .resident-portal-menu {
        &__list {
            list-style: none;
            margin: 0px;
            padding: 0px;
        }

        &__item {
            margin: 0px;
            padding: 0px;
        }

        // Caly wiersz jest klikalny, a wyglada jak pozostale wiersze podmenu
        &__row {
            width: 100%;
            box-sizing: border-box;
            margin: 0px;
            border: none;
            background-color: transparent;
            font-family: inherit;
            text-align: left;
            text-decoration: none;
            color: inherit;
            cursor: pointer;

            &:hover,
            &:focus,
            &:visited {
                text-decoration: none;
                color: inherit;
            }
        }
    }
</style>
